import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import OfferingForm from '../../Components/Offerings/OfferingForm';
import { createOffering } from '../../api/offerings';
import Header from '../../Components/Header/Header';
import Sidebar from '../../Components/Sidebar/Sidebar';
import '../AdventureShared.css';
import './CreateOfferingPage.css';

export default function CreateOfferingPage() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (payload) => {
    setIsSubmitting(true);
    try {
      await createOffering(payload);
      navigate('/facilitate/offerings');
    } catch (err) {
      console.error("Failed to create offering", err);
      alert("Failed to create offering. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="CreateOfferingPage">
      <div className="adventurePageContainer">
        <div className="headerContain">
          <Header />
        </div>

        <div className="adventurePageContainer2">
          <div className="sidebarContain">
            <Sidebar />
          </div>

          <main className="adv-page-main animate-fade-in">
            <div className="off-create-middle">
              <div className="off-create-header">
                <button className="off-back-btn" onClick={() => navigate('/facilitate/offerings')}>
                  ← Back to Offerings
                </button>
                <h1 className="off-create-title">Create a New Offering</h1>
              </div>

                <OfferingForm
                  onSubmit={handleSubmit}
                  isSubmitting={isSubmitting}
                  onCancel={() => navigate('/facilitate/offerings')}
                />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
